import axios from 'axios';
import { API_BASE_URL } from '../config/api.config';

const API_URL = API_BASE_URL;

export interface Role {
  _id: string;
  name: string;
  description?: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateRoleInput {
  name: string;
  description?: string;
}

export interface UpdateRoleInput {
  name?: string;
  description?: string;
  isActive?: boolean;
}

export const roleService = {
  /**
   * Get all roles
   */
  async getAllRoles(token: string, filters?: { isActive?: boolean }): Promise<Role[]> {
    const response = await axios.get(`${API_URL}/roles`, {
      headers: { Authorization: `Bearer ${token}` },
      params: filters || {}
    });
    return response.data.data;
  },

  /**
   * Get role by ID
   */
  async getRoleById(roleId: string, token: string): Promise<Role> {
    const response = await axios.get(`${API_URL}/roles/${roleId}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data.data;
  },

  /**
   * Create new role
   */
  async createRole(data: CreateRoleInput, token: string): Promise<Role> {
    const response = await axios.post(`${API_URL}/roles`, data, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data.data;
  },

  /**
   * Update role
   */
  async updateRole(roleId: string, data: UpdateRoleInput, token: string): Promise<Role> {
    const response = await axios.put(`${API_URL}/roles/${roleId}`, data, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data.data;
  },

  /**
   * Delete role
   */
  async deleteRole(roleId: string, token: string): Promise<void> {
    await axios.delete(`${API_URL}/roles/${roleId}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
  }
};
